import { useState } from "preact/hooks";
import { serverOptions } from "../../data/interfaces.ts";

interface SignUpFormProps {
  toggleForm: () => void;
  initialEmail?: string;
  initialIgn?: string;
  initialServer?: string;
  initialGame?: string;
}

export function SignUpForm({ toggleForm, initialEmail, initialIgn, initialServer, initialGame }: SignUpFormProps) {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState(initialEmail || "");
  const [ign, setIgn] = useState(initialIgn || "");
  const [server, setServer] = useState(initialServer || "");
  const [game, setGame] = useState(initialGame || "Dofus 3");

  const nextStep = () => setStep(2);
  const prevStep = () => setStep(1);

  return (
    <>
      <div class="text-center mb-8">
        <h2 class="text-3xl font-black text-white mb-2">Create Account</h2>
        <div class="flex justify-center items-center gap-2">
          <div class={`h-1.5 w-8 rounded-full transition-all duration-300 ${step === 1 ? "bg-accent" : "bg-gray-700"}`}></div>
          <div class={`h-1.5 w-8 rounded-full transition-all duration-300 ${step === 2 ? "bg-accent" : "bg-gray-700"}`}></div>
        </div>
      </div>

      <form method="POST" class="space-y-5">
        <input type="hidden" name="formType" value="signup" />
        
        {step === 1 && (
          <div class="space-y-5 animate-in fade-in slide-in-from-right-4 duration-300">
            <div>
              <label class="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2 ml-1">
                Email Address
              </label>
              <input
                name="email"
                type="email"
                required
                placeholder="name@example.com"
                value={email}
                onInput={(e) => setEmail((e.target as HTMLInputElement).value)}
                class="w-full px-5 py-4 bg-gray-900/50 border border-white/5 rounded-2xl text-white placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-accent/50 focus:border-accent/50 transition-all duration-300"
              />
            </div>
            <div>
              <label class="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2 ml-1">
                Password
              </label>
              <input
                type="password"
                name="password"
                required
                placeholder="••••••••"
                class="w-full px-5 py-4 bg-gray-900/50 border border-white/5 rounded-2xl text-white placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-accent/50 focus:border-accent/50 transition-all duration-300"
              />
            </div>
            <div>
              <label class="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2 ml-1">
                Confirm Password
              </label>
              <input
                type="password"
                name="confirm_password"
                required
                placeholder="••••••••"
                class="w-full px-5 py-4 bg-gray-900/50 border border-white/5 rounded-2xl text-white placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-accent/50 focus:border-accent/50 transition-all duration-300"
              />
            </div>
            <button
              type="button"
              onClick={nextStep}
              disabled={!email}
              class="w-full bg-accent hover:bg-yellow-500 disabled:opacity-50 disabled:cursor-not-allowed text-black font-bold py-4 px-6 rounded-2xl shadow-lg shadow-accent/20 transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] mt-4 flex items-center justify-center gap-2"
            >
              Continue
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </button>
          </div>
        )}

        {step === 2 && (
          <div class="space-y-5 animate-in fade-in slide-in-from-right-4 duration-300">
            {/* Hidden fields for step 1 data to ensure they are submitted */}
            <input type="hidden" name="email" value={email} />

            <div>
              <label class="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2 ml-1">
                In-game Pseudo
              </label>
              <input
                name="ign"
                required
                placeholder="Pseudo"
                value={ign}
                onInput={(e) => setIgn((e.target as HTMLInputElement).value)}
                class="w-full px-5 py-4 bg-gray-900/50 border border-white/5 rounded-2xl text-white placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-accent/50 focus:border-accent/50 transition-all duration-300"
              />
            </div>
            <div>
              <label class="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2 ml-1">
                Server
              </label>
              <select
                name="server"
                required
                value={server}
                onChange={(e) => setServer((e.target as HTMLSelectElement).value)}
                class="w-full px-5 py-4 bg-gray-900/50 border border-white/5 rounded-2xl text-white appearance-none focus:outline-none focus:ring-2 focus:ring-accent/50 focus:border-accent/50 transition-all duration-300 cursor-pointer"
              >
                <option value="" disabled>Select your server</option>
                {serverOptions.map((s) => (
                  <option key={s} value={s} class="bg-gray-900">{s}</option>
                ))}
              </select>
            </div>
            <div>
              <label class="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2 ml-1">
                Game Version
              </label>
              <select
                name="game"
                required
                value={game}
                onChange={(e) => setGame((e.target as HTMLSelectElement).value)}
                class="w-full px-5 py-4 bg-gray-900/50 border border-white/5 rounded-2xl text-white appearance-none focus:outline-none focus:ring-2 focus:ring-accent/50 focus:border-accent/50 transition-all duration-300 cursor-pointer"
              >
                <option value="Dofus 3" class="bg-gray-900">Dofus 3</option>
                <option disabled value="WIP" class="bg-gray-900">Touch and Retro soon™</option>
              </select>
            </div>

            <div class="flex gap-4 mt-6">
              <button
                type="button"
                onClick={prevStep}
                class="flex-1 bg-white/5 hover:bg-white/10 text-white font-bold py-4 px-6 rounded-2xl transition-all duration-300 border border-white/5"
              >
                Back
              </button>
              <button
                type="submit"
                class="flex-[2] bg-accent hover:bg-yellow-500 text-black font-bold py-4 px-6 rounded-2xl shadow-lg shadow-accent/20 transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98]"
              >
                Create Account
              </button>
            </div>
          </div>
        )}
      </form>
      
      <div class="mt-8 text-center border-t border-white/5 pt-6">
        <button
          type="button"
          onClick={toggleForm}
          class="text-sm font-semibold text-gray-400 hover:text-accent transition-colors duration-300"
        >
          Already have an account? <span class="text-accent">Sign in</span>
        </button>
      </div>
    </>
  );
}
